import PanelRowValues from './PanelRowValues'
import { connect } from 'react-redux'

const mapStateToProps = state => {
    return {
        yearsEvolution: state.FILTERS.evolutionFilter
    }
  }
  
export default connect(mapStateToProps)(PanelRowValues)


// WEBPACK FOOTER //
// ./src/modules/Charts/PanelRow/PanelRowValues/index.js